import '../../../scss/hotfood/components/hotfood-fable.scss'

import {
  Body1,
  Button,
  ButtonGroup,
  Display3,
  Flex,
  Modal,
} from '@sainsburys-tech/fable'
import { AlertCircleFilled } from '@sainsburys-tech/icons'
import React from 'react'
interface IProps {
  handleClose: () => void
  handleSave: (value: boolean) => void
  isOpen: boolean
}

const CounterManualInputModal = (props: IProps) => (
  <Modal
    size='md'
    onClose={() => props.handleClose()}
    isOpen={props.isOpen}
    testid='manual-input-modal'
    className='c-counter-manual-modal'
  >
    <Flex direction='column' justifyContent='left' gap='md'>
      <Flex alignItems='center' gap='sm'>
        <AlertCircleFilled className='c-form-alert-icon-red-modal' />
        <Display3 data-testid='manual-input-modal-title'>
          Changing to manual checks
        </Display3>
      </Flex>

      <div style={{ textAlign: 'left', margin: '1rem 0' }}>
        <Body1>
          You're changing to manual checks. Please only do so if you're unable
          to use your Bluetooth probe. To report an issue, please refer to
          Sainsbury's Tech Assist.
        </Body1>
      </div>

      <ButtonGroup align='center'>
        <Button
          testid='manual-input-button'
          onClick={() => props.handleSave(false)}
          isFullWidth={true}
        >
          Change to manual checks
        </Button>
        <Button
          onClick={() => props.handleClose()}
          testid='manual-input-cancel-button'
          variant='secondary'
          isFullWidth={true}
          style={{
            backgroundColor:
              'var(--fable-color-background-secondary-default, #ffffff)',
          }}
        >
          Cancel
        </Button>
      </ButtonGroup>
    </Flex>
  </Modal>
)

export default CounterManualInputModal
